// extracted by css-extract-rspack-plugin
export default {"SavedReplies":"SavedReplies-module__SavedReplies__a2hcnRx"};